import CompetitiveMetrics from "./CompetitiveMetrics";

export default CompetitiveMetrics;
